// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.score-reaction-overlay {
  position: fixed;
  inset: 0;
  z-index: 10010;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  pointer-events: none;
  isolation: isolate;
}
.score-reaction-stage {
  width: min(520px, calc(100vw - 24px), calc(100dvh * 1.05));
  aspect-ratio: 4 / 3;
  background: transparent;
  -webkit-user-select: none;
          user-select: none;
}
.score-reaction-art {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-color: transparent;
}
.score-reaction-dismiss {
  position: absolute;
  top: max(12px, env(safe-area-inset-top));
  right: max(12px, env(safe-area-inset-right));
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  pointer-events: auto;
  border-radius: 50%;
  background: var(--ps-bg-surface);
  color: var(--ps-text-primary);
  border: 1px solid var(--ps-border);
  transition: transform .15s ease, background-color .15s ease;
}
.score-reaction-dismiss:hover { transform: scale(1.06); background: var(--ps-bg-hover); }
.score-reaction-dismiss:focus-visible { outline: 2px solid var(--ps-primary); outline-offset: 2px; }
@media (prefers-reduced-motion: reduce) { .score-reaction-dismiss:hover { transform: none; } }`, "",{"version":3,"sources":["webpack://./src/components/score-reactions/score-reactions.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;EAClC,2DAA2D;AAC7D;AACA,gCAAgC,sBAAsB,EAAE,8BAA8B,EAAE;AACxF,wCAAwC,oCAAoC,EAAE,mBAAmB,EAAE;AACnG,0CAA0C,gCAAgC,eAAe,EAAE,EAAE","sourcesContent":[".score-reaction-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10010;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  pointer-events: none;\n  isolation: isolate;\n}\n.score-reaction-stage {\n  width: min(520px, calc(100vw - 24px), calc(100dvh * 1.05));\n  aspect-ratio: 4 / 3;\n  background: transparent;\n  user-select: none;\n}\n.score-reaction-art {\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-color: transparent;\n}\n.score-reaction-dismiss {\n  position: absolute;\n  top: max(12px, env(safe-area-inset-top));\n  right: max(12px, env(safe-area-inset-right));\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  pointer-events: auto;\n  border-radius: 50%;\n  background: var(--ps-bg-surface);\n  color: var(--ps-text-primary);\n  border: 1px solid var(--ps-border);\n  transition: transform .15s ease, background-color .15s ease;\n}\n.score-reaction-dismiss:hover { transform: scale(1.06); background: var(--ps-bg-hover); }\n.score-reaction-dismiss:focus-visible { outline: 2px solid var(--ps-primary); outline-offset: 2px; }\n@media (prefers-reduced-motion: reduce) { .score-reaction-dismiss:hover { transform: none; } }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
